@if (hasIcon) {
  <div class="icon-container flex items-center justify-start">
    <mat-icon>{{ icon$ | async }}</mat-icon>
  </div>
}

<div class="mat-typography flex-1">
  <div class="flex">
    <ng-content select="input" />
    <ng-content select="button" />
    <ng-content />
  </div>
</div>
